export default __webpack_public_path__ + "static/puzzled-ffdaff9df3b04b91424fbb7a4f6681d3.svg";